export default function youtube() {
  // Play youtube video on click
  $('.play-youtube-video').each(function () {
    const $link = $(this).find('a');
    const selector = $link.attr('href').replace('#', '');
    const $target = $(`#${selector}, .${selector}`);

    const $otherVideo = $(this).closest('.wp-block-sage-group').find('video');

    if ($target.length) {
      $target.hide();
      $link.on('click', function (e) {
        e.preventDefault();
        const $autoplay = $target.clone();
        const src = `${$autoplay.find('iframe').attr('src')}&autoplay=1`;
        $autoplay.find('iframe').attr('src', src);
        $('#modal-youtube .modal-body').html($autoplay);
        $autoplay.show();
        $('#modal-youtube').modal();

        // Pause other video
        if ($otherVideo.length) {
          $otherVideo.get(0).pause();
        }
      });
    }

    $('#modal-youtube').on('show.bs.modal', function () {
      $('body').addClass('modal-open--youtube');
    });

    $('#modal-youtube').on('hidden.bs.modal', function () {
      $('#modal-youtube .modal-body').empty();
      $('body').removeClass('modal-open--youtube');
    });
  });
}
